<template>
  <div class="modal-card" style="width: 640px">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ title }}</p>
    </header>
    <section class="modal-card-body">
      <gmap-map
        :center="center"
        :zoom="zoom"
        style="width:98%; height: 50vh"
        ref="mapRefAdmin"
        :options="mapOptions"
      >
      </gmap-map>
    </section>
  </div>
</template>

<script>

export default {
  name: "ChartMap",
  props: {
    payload: Object,
    title: String
  },
  data() {
    
    // Цвета для групп (кодов)
    const colors = {
      0: "#000000", //unknown
      1: "#654321", //overview
      2: "#819c4e", //general
      3: "#08457e", //coastal
      4: "#cd5b45", //approach
      5: "#fadfad", //harbour
      6: "#e100e1", //berthing
    }

    return {
      // Main
      zoom: 3,
      center: {
        lat: 43.8062302,
        lng: 35.7006469
      },
      mapOptions: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true
      },
      layers: [],
      // Цвета для групп (кодов)
      colors: colors,
      map: null
    };
  },
  created(){
    //
  },
  mounted() {
    let $this = this

    if (this.$refs.mapRefAdmin){
      this.$refs.mapRefAdmin && this.$refs.mapRefAdmin.$mapPromise.then(map => {
        $this.map = map
        $this.showMap()
      })
    }
  },
  computed: {
    //
  },
  methods: {
    showMap(){
      let $this = this
      if($this.map){
        try {
          let coords = {
            north: parseFloat($this.payload.northernmost_latitude),
            south: parseFloat($this.payload.southernmost_latitude),
            east: parseFloat($this.payload.easternmost_longitude),
            west: parseFloat($this.payload.westernmost_longitude)
          }

          let rectangle = new google.maps.Rectangle({
            strokeColor: $this.getOptionsRec($this.payload.group_id),
            strokeOpacity: 1,
            strokeWeight: 0.5,
            fillColor: $this.getOptionsRec($this.payload.group_id),
            fillOpacity: 0.2,
            map: $this.map,
            bounds: coords
          });

          let bounds = rectangle.getBounds()
          let center = bounds.getSouthWest()
          
          $this.map.panTo(center)

          $this.layers.push(rectangle)
        }
        catch (e){
          console.log(e)
        }
      }
    },
    cleanMap(updated_data){
      let $this = this
      $this.layers.forEach(function(layer){
        layer.setMap(null)
      })
      if(updated_data){
        $this.payload = new_data
        $this.showMap()
      }
    },
    // Helper получить цвет на категорию
    getOptionsRec(index){
      return this.colors[index]
    }
  }
};
</script>